import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Branch from 'src/app/model/branch/branch';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { LoadingService } from '../loading.service';
import { SnackService } from '../snack.service';
import { Observable } from 'rxjs';
import { _get } from '../base.service';

@Injectable({
  providedIn: 'root',
})
export class BranchControllerRequestService {
  private static BASE_URL = '/branches';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserializePage = (res) => {
    const result: ProperPageResult<Branch> = new ProperPageResult();
    result.totalItems = res.totalItems;
    result.items = res.items;
    return result;
  };

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(BranchControllerRequestService.BASE_URL, requestServices);
  }

  public getPaged(): Promise<ProperPageResult<Branch>> {
    return this.get(
      `?filters=&showArchived=false&sortDirection=ASC&sortProperty=name&page=0&size=30`,
      this.deserializePage
    ).toPromise();
  }
}
